import React from 'react';

// Lead Ecosystem Doctrine §13–19 — small inline identity pill.
// Additive only: rendered next to an existing name/identifier. No layout change.
const TYPE_CLS = {
  RL: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  EL: 'bg-orange-100 text-orange-700 border-orange-200',
  WL: 'bg-rose-100 text-rose-700 border-rose-200',
};

export const LeadIdentityBadge = ({ leadType, leadSource, className = '' }) => {
  if (!leadType) return null;
  const cls = TYPE_CLS[leadType] || 'bg-slate-100 text-slate-600 border-slate-200';
  return (
    <span
      className={`inline-flex items-center align-middle px-1.5 py-0.5 rounded-md text-[10px] font-semibold border ${cls} ${className}`}
      title={`Lead ${leadType}${leadSource ? ' · ' + leadSource : ''}`}
      data-testid="lead-identity-badge"
    >
      {leadType}{leadSource ? ` · ${leadSource}` : ''}
    </span>
  );
};

export default LeadIdentityBadge;
